export const lowerCased = (str: string) => str.toLowerCase()
